import { HttpClient } from '@angular/common/http';
import { Component, Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Constant } from './pages/general/blog/constant';

@Injectable({ providedIn: 'any' })
export class AppService {
  constructor(
    private http: HttpClient,
  ){

  }
  getImagesForSocial() {
    return  this.http.get(environment.urlBackEnd + '/res/blog/all');
  }
  getProductByCode(code: any) {
    const headers: any = {
      'F-Language': localStorage.getItem('language')
    };
    return this.http.get(environment.urlBackEnd + Constant.api_get_product_code + code, {headers});
  }
  getProducts(body: any) {
    return this.http.post(
      environment.urlBackEnd + Constant.api_common_products_filter,
      body
    );
  }
}